/**
 * Centralized document.title helpers so every page/tab name follows the same
 * "<Page> | Pacer" convention.  See src/components/Common/RouteTitle.js for the
 * route-driven default, and src/constants/routeTitles.js for the route map.
 */
export const APP_NAME = 'Pacer';

/**
 * Format a page name into the canonical tab title.  A falsy page name yields
 * just the brand name (used as the catch-all default).
 */
export const formatTitle = (pageName) => (pageName ? `${pageName} | ${APP_NAME}` : APP_NAME);

/**
 * Set document.title to the canonical "<Page> | Pacer" form.  Use this from any
 * page that needs a data-driven title (e.g. "Report - <name>"); static page
 * titles are handled centrally via the route map and should not call this.
 */
export const setDocumentTitle = (pageName) => {
	document.title = formatTitle(pageName);
};
